<template>
  <div>
    <v-tooltip bottom :disabled="!isOverflowing">
      <template v-slot:activator="{ on }">
        <div class="status" v-on="on">
          <v-icon class="status__icon" :color="icon.color" size="17.5">
            {{ icon.type }}
          </v-icon>
          <span class="status__label" ref="label">{{ label }}</span>
        </div>
      </template>
      <span>{{ label }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { OPEN_STATUS } from "@/enums/open-status-type.js";
import { LOCATION_STATE_CODE } from "@/enums/facility-status-type.js";

export default {
  name: "FacilityStatusItem",
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: Number
    },
    code: {
      type: String
    },
    state: {
      type: Boolean
    }
  },
  data: () => ({
    isOverflowing: false
  }),
  computed: {
    icon() {
      const icon = {
        color: "primary",
        type: "icon-status-success"
      };

      if (
        this.code === LOCATION_STATE_CODE.SUCCESS ||
        this.type === OPEN_STATUS.OPEN ||
        this.state === true
      ) {
        icon.color = "teal";
        icon.type = "icon-status-success";
      } else if (
        this.code === LOCATION_STATE_CODE.WARNING ||
        this.type === OPEN_STATUS.CLOSED_TEMPORARILY
      ) {
        icon.color = "lime";
        icon.type = "icon-status-warning";
      } else if (
        this.code === LOCATION_STATE_CODE.ERROR ||
        this.type === OPEN_STATUS.CLOSED_PERMANENTLY ||
        this.state === false
      ) {
        icon.color = "pink";
        icon.type = "icon-status-error";
      }

      return icon;
    }
  },
  methods: {
    detectTextOverflow() {
      this.$nextTick(() => {
        const el = this.$refs.label;
        this.isOverflowing = el.scrollHeight > el.clientHeight;
      });
    }
  },
  mounted() {
    this.detectTextOverflow();
  }
};
</script>

<style lang="scss" scoped>
.status {
  display: flex;
  align-items: center;

  &__icon {
    margin-right: $spacing;
  }

  &__label {
    @include font-size(14px);
    line-height: 17.07px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
}
</style>
